// extracted by mini-css-extract-plugin
module.exports = {"root":"src_root__3TmMh","wrapper":"src_wrapper__3BP5T","body-light":"src_body-light__3Yhvy","body-dark":"src_body-dark__2jNQY"};